import con from '../../../connection';

const path = '/login';

const login = (url: string) => () => ({
  post: (param: {
    email: string,
    password: string,
  }) => con.post<{
    header: {
      status: string,
      status_code: number,
      messages: string[],
    },
    body: {
      data: {
        user_id: string,
        email: string,
        family_name: string,
        name: string,
        family_name_kana: string,
        name_kana: string,
        is_isp_owner: boolean,
      },
    },
  }>(url + path, param),
});

export default login;
